import { render } from "./BillingHistory.vue?vue&type=template&id=9bfd53f2&scoped=true"
import script from "./BillingHistory.vue?vue&type=script&lang=js"
export * from "./BillingHistory.vue?vue&type=script&lang=js"

import "./BillingHistory.vue?vue&type=style&index=0&id=9bfd53f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfd53f2"]])

export default __exports__